module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAARBJREFUKFOlksFVg1AURO+wcSkbDUusQEpICSlBK5BgAaEBCXaAHWAFpgO1gyzBlTbA83wEDyRKFvzNP+f/NzNv3hsx4+gQG8QszeMOI5SIzPiUKGl4qnJ2w/oROFhTmAOI9OOBsi+8vGclIxW8Vhm3/fsveLEmF/jVlpv/nDhyhPUELfgiJvI8ijojOjWCRcKbGmJnoQUHMaG7q5x9D+5UdlVGMSR0FryGlevwaGB9oR/jn3ktez4k6N73dYb/o5xgk+02XI26SlrfmlYWLxKP08pzPM+atvPb7lmcD0NwlD63Z7eVLgsjz44AscTY1FueRwlr2AjehyH6K9shInUxFVwbfMkoMYrJbJ9K1+H/N3ohcxClNV46AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/automode/进入自动模式.png
// module id = 295
// module chunks = 7